const brandConfig = {
  PARAM_NAME: "brand",
};

export { brandConfig };
